import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from './messages';
import { getStore, getExpire } from '@/util/util'
import constant from '@/config/constant'

Vue.use(VueI18n);
/**
 * 从localStorage中拿到用户的语言选择，如果没有，那默认中文。
 * @type {VueI18n}
 */


const i18n = new VueI18n({
    // locale: getStore("iotc_lang") || browserLang || 'zh-CN',
    locale: getStore("languagecode") || 'zh_CN',
    messages: getExpire('languagepackage') || {},
    silentTranslationWarn: true
});



export default i18n;



// WEBPACK FOOTER //
// ./src/locale/index.js